<template>
<div>
  <div class="row">
    <div class="col">
       <form v-on:submit.prevent="save"
          autocomplete="STOPPPAUTOCOMPLETE"
       >

        <input autocomplete="STOPPPAUTOCOMPLETE" name="hidden" type="text" style="display:none;">

        <div class="form-group">
          <label for="login">Login</label>
          <input
            type="text"
            class="form-control"
            v-model="form.login"
            disabled
            id="login"
          />
        </div>

        <div class="form-group">
          <label for="nome">Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="form.nome"
            id="nome"
          />
        </div>

        <div class="form-group">
          <label for="campo2">Email</label>
          <input
            type="text"
            class="form-control"
            v-model="form.email"
            id="campo2"
            autocomplete="STOPPPAUTOCOMPLETE"
          />
        </div>

        <div class="form-group">
          <label for="campo1">
            Senha (deixa em branco para não alterar)
          </label>
          <input
            type="password"
            class="form-control"
            v-model="form.password"
            id="campo1"
            autocomplete="STOPPPAUTOCOMPLETE"
          />
        </div>

        <div class="form-group">
          <label for="campo3">
            Repetir Senha (deixa em branco para não alterar)
          </label>
          <input
            type="password"
            class="form-control"
            v-model="form.password2"
            id="campo3"
            autocomplete="STOPPPAUTOCOMPLETE"
          />
        </div>

        <div v-if="form.password && form.password !== '' && form.password !== form.password2" class="alert alert-danger">Senhas não conferem</div>
        <div v-if="form.password && form.password !== '' && form.password === form.password2" class="alert alert-success">Senha será alterada ao salvar</div>

        <!-- <div class="form-group" v-if="token.role === 'CA'">
          <label for="email">Permissão</label>
          <select class="form-control" name="permissao" id="permissao" v-model="form.role">
            <option value="CO">Cliente</option>
            <option value="CA">Cooperativa</option>
          </select>
        </div> -->

        <div class="form-group">
          <label for="doc">Foto</label><br>
          <img
            v-if="form.filename"
            class="img-fluid img-thumbnail mb-3"
            style="max-height: 200px"
            :src="`${api}/api/v1/usuario/doc/${form.filename}?token=${jwt}&mimetype=${form.mimetype}`"
          />
          <vue-dropzone ref="doc" id="doc" :options="dropzoneOptions" v-on:vdropzone-success="updateDoc"></vue-dropzone>
        </div>

        <div class="form-group">
          <button class="btn btn-primary btn-raised btn-block">Atualizar</button>
          <router-link to="/" class="btn btn-danger btn-raised btn-block">Voltar</router-link>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import vueDropzone from 'vue2-dropzone';

export default {
  components: {
    vueDropzone
  },
  name: 'Perfil',
  data() {
    return {
      form: {
        _id: '',
        nome: '',
        email: '',
        login: '',
        password: '',
        password2: '',
        role: 'CO',
        email: '',
        mimetype: '',
        filename: '',
        originalname: ''
      },
      dropzoneOptions: this.$http.getDropzoneConfig(`usuario/upload`, 'post', {
        maxFiles: 1,
        addRemoveLinks: true,
        capture: true,
        dictDefaultMessage: 'Clique ou arraste arquivos aqui para UPLOAD',
        dictRemoveFile: 'Remover'
      })
    };
  },
  methods: {
    start() {
      this.$http.get(`/usuario/me`).then(response => {
        if (response.data) {
          this.form = response.data;
        }
      });
    },
    save() {
      this.$http.put(`/usuario`, this.form).then(res => {
        if (res.data.success) {
          this.$toasted.show('Atualizado com sucesso!', this.$custom.success);
        } else {
          this.$toasted.show(
            'Erro ao atualizar, entre em contato com o ADM!',
            this.$custom.error
          );
        }
      });
    },
    updateDoc(file, response) {
      this.form.mimetype = response.mimetype;
      this.form.filename = response.filename;
      this.form.originalname = response.originalname;
    }
  },
  beforeMount() {
    this.start();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/app/home/Perfil.vue